import SlimSelect from 'slim-select';

if(document.querySelector('.js-select-location')) {
  new SlimSelect({
    select: '.js-select-location',
    settings: {
      showSearch: false
    }
  });
}
